import { Flex, Icon, Text } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

export const StagingHeader = props => {
  let actionNode = null;
  let headerStr = "";

  if (props.manager.isSearching) {
    headerStr = `${appstr("Search")} "${props.manager.searchQuery}"`;
  } else if (props.manager.stagingState.root === null) {
    const nr = props.manager.branches.length;
    if (nr === 0) {
      headerStr = appstr("toporphans");
    } else {
      const label = nr === 1 ? "island" : "islands";
      headerStr = `${appstr("toporphans")} (${nr} ${label})`;
    }
  } else {
    actionNode = <Icon name="caret-up" onClick={props.manager.drillUp} />;
    headerStr = ` / ${props.manager.stagingState.root.FormatEmployeeLabel()}`;
  }

  return (
    <Flex direction="row" gap="8px">
      {actionNode}
      <Text element="h2" modifier="bold" size="small">
        {headerStr}
      </Text>
    </Flex>
  );
};
